(function () {
    'use strict';

    angular.module('app').controller('BusinessController', BusinessController);

    BusinessController.$inject = [
        '$rootScope',
        '$scope',
        '$routeParams',
        '$location',
        '$timeout',
        '$window',
        '$translate',
        '$filter',
        'blockUI',
        '$uibModal',
        'BusinessService',
        'LoyaltyService',
        'SelectService',
        'NotifyService',
        'SettingsService',
        'POSService',
        'TerminalService',
        'LANGS'
    ];

    function BusinessController(
        $rootScope,
        $scope,
        $routeParams,
        $location,
        $timeout,
        $window,
        $translate,
        $filter,
        blockUI,
        $uibModal,
        BusinessService,
        LoyaltyService,
        SelectService,
        NotifyService,
        SettingsService,
        POSService,
        TerminalService,
        LANGS
    ) {

        $scope.currencyList = {};

        $scope.model = {
            title: '',
            country: $rootScope.USER.country,
            time_zone: 'GMT',
            rate: 10,
            terminal_phone: $rootScope.USER.phone,
            referral_code: null
        };

        $scope.data = {};

        $scope.additionalSettings = {};
        $scope.additionalSettings_consent_multilang = MultilanguageHelper();
        $scope.additionalSettings_display_title_multilang = MultilanguageHelper();
        $scope.additionalSettings_display_description_multilang = MultilanguageHelper();
        $scope.additionalSettings_welcome_multilang = MultilanguageHelper();
        $scope.additionalSetting_initLocaleStrings = initLocaleStrings;
        $scope.additionalSetting_getSampleString = getSampleString;
        $scope.isWelcomeMessageSendChangeAllowed = isWelcomeMessageSendChangeAllowed;
        $scope.isWelcomeMessageHaveRequirevVariables = isWelcomeMessageHaveRequirevVariables;
        $scope.isConsentRequestRequiredChangeAllowed = isConsentRequestRequiredChangeAllowed;
        $scope.isConsentRequestMessageHaveRequirevVariables = isConsentRequestMessageHaveRequirevVariables;
        var block_additional_edit = blockUI.instances.get('edit_additional_settings');

        $scope.loyaltiesList = [];
        $scope.posesList = [];
        $scope.terminalsList = [];

        $scope.inlineMessage = '';

        $scope.image = {
            src: '',
            cropped: '',
            new: false,
            delete: false,
            loading: false
        }

        $scope.isPageMode = isPageMode;
        // $scope.makeCurrencyList = makeCurrencyList;
        $scope.getAdditionalSettings = getAdditionalSettings;
        $scope.saveAdditionalSettings = saveAdditionalSettings;
        $scope.loyaltiesUpdate = loyaltiesUpdate;
        $scope.posesUpdate = posesUpdate;
        $scope.terminalsUpdate = terminalsUpdate;

        $scope.getCountriesList = SelectService.getCountriesList;
        $scope.getTimezonesList = SelectService.getTimezonesList;

        $scope.getLocalizedPath = getLocalizedPath;

        $scope.external_access = [];

        var block_new_business = blockUI.instances.get('new_business'),
            block_legal_info = blockUI.instances.get('block_legal_info'),
            block_external_access = blockUI.instances.get('block_external_access');

        $scope.isPosBlockVisible = true;
        $scope.isTerminalsBlockVisible = true;

        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });

        $scope.currentTab = 'main';
        $scope.customer_additional_card_scope = [
            {
                value: 'business',
                title: 'Business',
            },
            {
                value: 'loyalty',
                title: 'Loyalty',
            }
        ];

        initController();

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Page mode display different parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */
        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        /**
         * Check parameter 'mode' in route ../loyalty/{mode}
         */
        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        function initPageMode() {
            $scope._pageMode = 'show';
            if (isRouteMode('create')) {
                $scope._pageMode = ($rootScope.BUSINESS) ? 'show' : 'create';
            } else {
                if (isRouteMode('settings')) {
                    $scope._pageMode = 'settings';
                } else {
                    if (isRouteMode('edit')) $scope._pageMode = 'edit';
                }
            }
        }

        /**
         * Init controller data
         */
        function initController() {
            $scope.additionalSettings_consent_multilang.initLangs(LANGS, $rootScope.LANG);
            $scope.additionalSettings_display_title_multilang.initLangs(LANGS, $rootScope.LANG);
            $scope.additionalSettings_display_description_multilang.initLangs(LANGS, $rootScope.LANG);
            $scope.additionalSettings_welcome_multilang.initLangs(LANGS, $rootScope.LANG);

            if ($routeParams['ref']) {
                $scope.model.referral_code = $routeParams['ref'];
                $scope.showReferralInput = true;
            }

            initPageMode();

            switch ($scope._pageMode) {
                case 'create':
                    doCreate();
                    break;
                case 'success':
                    doFinish();
                    break;
                case 'show':
                    doShow();
                    break;
                case 'edit':
                    doEdit();
                    break;
                case 'settings':
                    doShow();
                    break;
            }
        }

        /**
         * Load Business info from server
         */
        function _loadBusiness() {
            BusinessService.Get(function (success, data) {
                if (success) {
                    if (isPageMode('show')) {
                        $scope.loyaltiesUpdate();
                        $scope.posesUpdate();
                        $scope.terminalsUpdate();
                    } else if (isPageMode('settings')) {
                        $scope.getAdditionalSettings();
                    }
                } else {
                    if (data.code && data.code == 30)
                        $location.path('/business/create');
                }
            });
        }

        function doEdit() {
            $location.path('/business');
        }

        // *********************************************************************************************
        //  CREATE/EDIT PART
        // *********************************************************************************************

        function doCreate() {
            BusinessService.Get(function (success, data) {
                if (success) {
                    $location.path('/business');
                } else {
                    if (data.code && data.code == 30) {
                        $rootScope.PAGE.style = 'no-menu';
                        $rootScope.BUSINESS_EXIST = false;
                        $scope.model.country = $rootScope.USER.country;

                        if (!$scope.model.country) {
                            SettingsService.CurrentCountry(function (success, response) {
                                $scope.model.country = response.code;
                            });
                        }
                    }
                }
            });
        }

        function doFinish() {
            $rootScope.PAGE.style = 'no-menu';
        }

        /**
         * Send data to server for create new business
         */
        $scope.newBusiness = function () {
            block_new_business.start();
            // $scope.businessState.loading();
            if (($scope.form.title.$valid
                    && ($scope.model.rate_type == 'bonus' || $scope.model.rate_type == 'discount')
                    && $scope.form.bonusrate.$valid
                    && $scope.form.discountrate.$valid
                    && $scope.model.rate > 0)
                || ($scope.form.title.$valid
                    && $scope.model.rate_type == 'none')) {

                if ($scope.model.rate_type == 'none')
                    $scope.model.rate = $scope.model.rate_type = null;

                BusinessService.Create($scope.model, function (success, data) {
                    if (success) {
                        $window.ga('send', 'event', 'Business panel', 'Business Registration', 'Registration');

                        $location.path('/business');
                        $location.hash('top');

                        $rootScope.hideWarnings = true;
                        var modalInstance = $uibModal.open({
                            animation: true,
                            keyboard: false,
                            size: 'lg',
                            templateUrl: 'app/templates/message.newbusiness.html',
                            controllerAs: 'popup',
                            windowClass: 'welcome-message-wrapper',
                            controller: function ($uibModalInstance) {
                                var popup = this;

                                popup.getLocalizedPath = getLocalizedPath;
                                popup.register = {
                                    login: data.terminal.login,
                                    password: data.terminal.password
                                };

                                $timeout(function () {
                                    popup.links = {
                                        loyalty: '<a target="_blank" class="link bold" href="/loyalties">' + data.title + '</a>',
                                        pos: '<a target="_blank" class="link bold" href="/pos">' + data.title + '</a>',
                                        lessons: '<a target="_blank" class="link bold" href="https://' + appConfig.platformParams.main_site[$rootScope.LANG] +
                                            '/' + popup.getLocalizedPath(data.country, $rootScope.LANG) + '/learning/">' +
                                            $filter('translate')('TEXT_LESSONS_ONLINE') + '</a>',
                                        knowledgebase: '<a target="_blank" class="link bold" href="https:' +
                                            appConfig.platformParams.main_site[$rootScope.LANG] + '/' + popup.getLocalizedPath(data.country, $rootScope.LANG) +
                                            '/knowledgebase/">' + $filter('translate')('TEXT_KNOWLEDGEBASE') + '</a>'
                                    };
                                });

                                popup.onCancel = function (exit) {
                                    $uibModalInstance.close();
                                };
                            }
                        });

                        $scope.inlineMessage = '';
                    } else {
                        var isInlineMessage = data.code == 1 || data.code == 2 || data.code == 62;
                        if (isInlineMessage)
                            $scope.inlineMessage = data.message;
                    }
                    block_new_business.stop();
                });

            } else {
                if ($scope.model.rate == 0) {
                }
                $scope.form.bonusrate.$error.required = $scope.form.discountrate.$error.required = true;

                $scope.form.title.$dirty = $scope.form.bonusrate.$dirty
                    = $scope.form.discountrate.$dirty
                    = true;
                $scope.inlineMessage = 'Please, check if all data are correct.';
                block_new_business.stop();
            }

            return false;
        };

        $scope.onShowReferralInput = function () {
            $scope.showReferralInput = true;
        };

        // *********************************************************************************************
        //  SHOW EXISTS PART
        // *********************************************************************************************

        function doShow() {
            _loadBusiness();
        }

        $scope.activeLoyaltiesCount = function () {
            var active = 0;
            if ($scope.loyaltiesList) {
                $scope.loyaltiesList.forEach(function (item) {
                    if (item.active) active += 1;
                });
            }
            return active;
        };

        $scope.activePOSesCount = function () {
            var active = 0;
            if ($scope.posesList) {
                $scope.posesList.forEach(function (item) {
                    if (item.active) active += 1;
                });
            }
            return active;
        };

        $scope.activeTerminalsCount = function () {
            var active = 0;
            if ($scope.terminalsList) {
                $scope.terminalsList.forEach(function (item) {
                    if (item.active) active += 1;
                });
            }
            return active;
        };

        /**
         * Load loyalties list from server
         */
        function loyaltiesUpdate() {
            LoyaltyService.All(function (success, data) {
                if (success) {
                    $scope.loyaltiesList = angular.copy(data);
                }
            });
        }

        /**
         * Load POS-es list from server
         */
        function posesUpdate() {
            POSService.All({}, function (success, data) {
                if (success) {
                    $scope.posesList = data;
                }
            });
        }

        /**
         * Load Terminals list from server
         */
        function terminalsUpdate() {
            TerminalService.All(function (success, data) {
                if (success) {
                    $scope.terminalsList = $rootScope.TERMINALS;
                }
            });
        }

        $scope.getLoyaltyTitle = function (id) {
            var l = itemByIndex($scope.loyaltiesList, id);
            return l ? l.title : '';
        };

        $scope.getPOSTitle = function (id) {
            var p = itemByIndex($scope.posesList, id);
            return p ? p.title : '';
        };

        /**
         * Loyalties enable/disable
         */
        $scope.onLoyaltyToggleClick = function (loyalty) {
            $scope.loyaltyToggleLoaded = true;
            var post_data = {
                id: loyalty.id,
                active: 1 * !Boolean(loyalty.active)
            };
            LoyaltyService.Change(loyalty.id, post_data, function (success, data) {
                $scope.loyaltyToggleLoaded = false;
            });
        };

        /**
         * POS enable/disable click
         */
        $scope.onPOSToggleClick = function (pos) {
            // $scope.posState.loading();
            var post_data = {
                id: pos.id,
                active: 1 * !Boolean(pos.active)
            };
            POSService.Change(pos.id, post_data, function (success, data) {
                // if (success) {
                //     $scope.posesUpdate(data);
                // }
            });
        };

        /**
         * Terminal enable/disable click
         */
        $scope.onTerminalToggleClick = function (terminal) {
            var post_data = {
                id: terminal.id,
                active: 1 * !Boolean(terminal.active)
            };
            TerminalService.Change(terminal.id, post_data, function (success, data) {
            });
        };

        $scope.terminalAppLink = function (terminal) {
            return '{0}/signin?login={1}'.format($rootScope.appConfig.terminal, terminal.phone);
        };

        $scope.onCleanInlineMessage = function () {
            $scope.inlineMessage = '';
        };

        /**
         * New loyalty click
         */
        $scope.newLoyalty = function () {
            $location.path('/loyalties/create');
        };

        $scope.onReferalCodeChange = function () {
            if ($scope.model.referral_code)
                $timeout(function () {
                    BusinessService.CheckReferralCode($scope.model.referral_code, function (success, response) {
                        if (success) {
                            $scope.form.referral_code.$valid = true;
                            $scope.form.referral_code.$invalid = false;
                        } else {
                            if (response.code == 32) {
                                $scope.form.referral_code.$invalid = true;
                                $scope.form.referral_code.$valid = false;
                                $scope.form.referral_code.$dirty = true;
                            }

                        }
                    });
                }, 500);
        };

        $scope.$watchCollection('[model.title, model.rate]', function (newValues, oldValues) {
            $scope.inlineMessage = '';
        });

        $scope.$watch('model.rate_type', function (newValues, oldValues) {
            var br = angular.element('#bonusrate');
            var dr = angular.element('#discountrate');
            br.select();
            switch ($scope.model.rate_type) {
                case 'bonus':
                    $timeout(function () {
                        br.select();
                    }, 300);
                    break;
                case 'discount':
                    $timeout(function () {
                        dr.select();
                    }, 300);
                    break;
            }
        });

        $rootScope.$watchCollection('[COUNTRIES[LANG],TIMEZONES[LANG]]', function (newCollection, oldCollection, scope) {
            if (newCollection[0]) {
                $scope.data.countriesList = angular.copy($rootScope.COUNTRIES[$rootScope.LANG]);
            }
            if (newCollection[1]) {
                $scope.data.timezonesList = angular.copy($rootScope.TIMEZONES[$rootScope.LANG]);
            }
            if (newCollection[0] && newCollection[1] && $scope._pageMode === 'create') {
                var l = $scope.data.countriesList,
                    c = itemByIndex($scope.data.countriesList, $scope.model.country);

                if ($scope.model)
                    $scope.model.time_zone = itemByIndex($scope.data.timezonesList, c.time_zone).id;
            }
        }, true);

        $scope.$watch('model.country', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                var c = itemByIndex($scope.data.countriesList, newValue);

                if ($scope.model && !!c && itemByIndex($scope.data.timezonesList, c.time_zone)) {
                    $scope.model.time_zone = itemByIndex($scope.data.timezonesList, c.time_zone).id;
                }

            }
        });

        // *********************************************************************************************
        //  ADDITIONAL SETTINGS
        // *********************************************************************************************

        /**
         * Load additional settings list from server
         */
        function getAdditionalSettings() {
            block_additional_edit.start();
            BusinessService.Settings(function (success, data) {
                if (success) {
                    $scope.additionalSettings = data;

                    console.info('additionalSettings', $scope.additionalSettings);
                    $scope.additionalSetting_initLocaleStrings($scope.additionalSettings);
                }
                block_additional_edit.stop();
            });
        }

        function saveAdditionalSettings() {
            var post_data = angular.copy($scope.additionalSettings);

            block_additional_edit.start();

            function receiveResult(success, data) {
                if ($scope.image.delete && !$scope.image.new) {
                    BusinessService.DeletePhoto(function (success, img_data) {
                        if (success) {
                            $scope.additionalSettings = img_data;
                            $scope.image.delete = false;
                            $scope.image.src = '';
                            $scope.image.new = false;
                            NotifyService.Success('', false);
                        }
                    })
                } else if ($scope.image.new) {
                    var image = $scope.image.cropped || $scope.image.src;
                    BusinessService.UploadPhoto(image, function (success, img_data) {
                        if (success) {
                            $scope.additionalSettings = img_data;
                            $scope.image.new = false;
                            $scope.image.src = '';
                            $scope.image.delete = false;
                            NotifyService.Success('', false);
                        }
                    });
                } else {
                    $scope.additionalSettings = data;
                    NotifyService.Success('', false);
                }
                $scope.additionalSetting_initLocaleStrings($scope.additionalSettings);
                block_additional_edit.stop();
            }

            BusinessService.SettingsEdit(post_data, receiveResult);
        }

        $scope.isFormValid = function (form) {
            return isFormValid(form);
        };

        $scope.onSaveAdditionalSettings = function (form) {
            if (isFormValid(form)) {
                saveAdditionalSettings();
            }
        };

        $scope.onCancelEditAdditionalSettings = function () {
            $scope.additionalSettings = {};
            $scope.getAdditionalSettings();
        };

        /**
         * Init loyalty string
         */
        function initLocaleStrings(additional_settings) {
            $scope.additionalSettings_consent_multilang.initStrings(additional_settings,
                ['consent_request_message', 'platform_consent_request_message', 'platform_consent_request_message_business_default']);
            $scope.additionalSettings_display_title_multilang.initStrings(additional_settings,
                ['public_title']);
            $scope.additionalSettings_display_description_multilang.initStrings(additional_settings,
                ['public_description']);
            $scope.additionalSettings_welcome_multilang.initStrings(additional_settings,
                ['welcome_message', 'platform_welcome_message', 'platform_welcome_message_business_default']);
        }

        /**
         * Event receive when change editing language
         */
        $scope.onChangeLanguage_consent = function (form, new_lang) {
            if (isFormValid(form)) {
                $scope.additionalSettings_consent_multilang.selected(new_lang);
            }
        };
        $scope.onChangeLanguage_display_title = function (form, new_lang) {
            if (isFormValid(form)) {
                $scope.additionalSettings_display_title_multilang.selected(new_lang);
            }
        };
        $scope.onChangeLanguage_display_description = function (form, new_lang) {
            if (isFormValid(form)) {
                $scope.additionalSettings_display_description_multilang.selected(new_lang);
            }
        };
        $scope.onChangeLanguage_welcome = function (form, new_lang) {
            if (isFormValid(form)) {
                $scope.additionalSettings_welcome_multilang.selected(new_lang);
            }
        };

        $scope.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();

            var imageType = file.type,
                isPng = imageType === 'image/png';

            reader.onload = function (e) {
                var img = new Image();

                img.onload = function () {
                    var canvas = document.getElementById('file-canvas'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    if (file.size > maxAllowedSize) {
                        const scalingFactor = Math.sqrt(maxAllowedSize / file.size);
                        width *= scalingFactor;
                        height *= scalingFactor;
                    }

                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);

                    var resizedImageDataUrl;

                    if (isPng) {
                        resizedImageDataUrl = canvas.toDataURL('image/png');
                    } else {
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', 1);
                    }

                    if (resizedImageDataUrl.length > maxAllowedSize) {
                        var scale = 0.95,
                            quality = 1;

                        do {
                            width = Math.round(img.width * scale);
                            height = Math.round(img.height * scale);

                            canvas.width = width;
                            canvas.height = height;
                            ctx.clearRect(0, 0, width, height);
                            ctx.drawImage(img, 0, 0, width, height);

                            if (isPng) {
                                resizedImageDataUrl = canvas.toDataURL('image/png');
                            } else {
                                quality = Math.max(quality - 0.05, 0.1);
                                resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                            }

                            scale -= 0.05;
                        } while (
                            resizedImageDataUrl.length > maxAllowedSize &&
                            width > 50 && height > 50
                        );
                    }

                    $scope.$apply(function () {
                        $scope.image.new = true;
                        $scope.image.src = resizedImageDataUrl;
                        $scope.image.cropped = '';
                        $scope.image.loading = false;
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
            $scope.image.loading = true;
        };

        $scope.initImgCrop = function () {
            var file = angular.element(document.getElementById('businessPicture'));
            file.on('change', $scope.handleFileSelect);
        };

        $scope.deleteBusinessPhoto = function () {
            if ($scope.image.new) {
                $scope.image.new = false;
                $scope.image.src = '';
                $scope.image.cropped = '';
            } else if ($scope.additionalSettings.photos && $scope.additionalSettings.photos.length > 0) {
                delete $scope.additionalSettings.photos;
                $scope.image.delete = true;
            }
            var file = angular.element(document.getElementById('businessPicture'));
            angular.element(file).val(null);
        };

        $scope.cropBusinessPhoto = function () {
            $uibModal.open({
                animation: false,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.crop-image.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-full',
                controller: function ($uibModalInstance) {
                    var popup_crop = this;
                    popup_crop.image = angular.copy($scope.image);

                    popup_crop.onCancelClick = function () {
                        $uibModalInstance.close();
                    }

                    popup_crop.onCropImage = function () {
                        $scope.image = angular.copy(popup_crop.image);
                        $uibModalInstance.close();
                    }
                }
            })
        };

        function getSampleString(message, platform_message, default_message, form_input, required_pattern) {
            if (form_input.$dirty && (form_input.required || form_input.$invalid)) {
                return '';
            }

            if (message === undefined || message === null || message.length == 0) {
                if (default_message === undefined || default_message === null || default_message.length == 0) {
                    return platform_message;
                }
                message = default_message;
            }

            var sample_message = message;

            if (required_pattern !== undefined && required_pattern !== null && required_pattern.length > 0) {
                var required_regex = new RegExp(required_pattern, 'g');
                sample_message = message.replace(required_regex, platform_message);
            }

            return sample_message;
        }

        function isWelcomeMessageSendChangeAllowed() {
            if ($scope.additionalSettings.platform_welcome_message_required === 'business' &&
                $scope.additionalSettings.platform_welcome_message_send_change_allow) {
                return true;
            }

            return false;
        }

        function isWelcomeMessageHaveRequirevVariables() {
            if ($scope.additionalSettings.welcome_message_required_pattern &&
                $scope.additionalSettings.welcome_message_required_pattern.length > 0) {
                return true;
            }

            return false;
        }

        function isConsentRequestRequiredChangeAllowed() {
            if ($scope.additionalSettings.platform_consent_request_required === 'business' &&
                $scope.additionalSettings.platform_consent_request_send_change_allow) {
                return true;
            }

            return false;
        }

        function isConsentRequestMessageHaveRequirevVariables() {
            if ($scope.additionalSettings.consent_message_required_pattern &&
                $scope.additionalSettings.consent_message_required_pattern.length > 0) {
                return true;
            }

            return false;
        }


        $scope.onChangeTab = function (tab) {
            console.info('TAB', tab);
            // $location.url($location.$$path + '?tab=' + tab);
            $scope.currentTab = tab;
            onSwitchTab(tab)
        };

        function onSwitchTab(tab) {
            switch (tab) {
                case 'financial':
                    showFinancialTab();
                    break;
                case 'external_access':
                    loadExternalAccessInfo();
                    loadExternalAccessScope();
                    break;
            }
        }

        // =============================================================================================================
        // FINANCIAL INFORMATION TAB
        // =============================================================================================================

        function showFinancialTab() {
            block_legal_info.start();
            BusinessService.LegalInfo(function (success, data) {
                if (success) {
                    $scope.legal_info = data;
                }
                block_legal_info.stop();
            });
        }

        $scope.changeFinancial = function (form) {
            block_legal_info.start();
            var post_data = angular.copy($scope.legal_info);
            BusinessService.LegalInfoEdit(post_data, function (success, data) {
                if (success) {
                    angular.element('#form_financial').scope().form_financial.$dirty = false;
                    NotifyService.Success('', false);
                }
                block_legal_info.stop();
            });
        }

        // =============================================================================================================
        // END FINANCIAL INFORMATION TAB
        // =============================================================================================================

        // *********************************************************************************************
        //  EDIT EXTERNAL ACCESS TEMPLATES
        // *********************************************************************************************

        $scope.addExternalAccess = function () {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/business/modals/modal.external-access.add.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.data = {
                        title: '',
                        scope: []
                    }
                    popup.scope = [];
                    $scope.data.scope.forEach(function (el) {
                        popup.scope.push({
                            title: el.title,
                            value: el.value,
                            checked: true
                        })
                    })
                    popup.onCreateAccess = function () {
                        popup.scope.forEach(function (el) {
                            if (el.checked) {
                                popup.data.scope.push(el.value)
                            }
                        })
                        BusinessService.AddExternalAccess(popup.data, function (success, data) {
                            if (success) {
                                NotifyService.Success('', false);
                                loadExternalAccessInfo();
                                $uibModalInstance.close();
                            }
                        })
                    }
                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            })
        }

        $scope.onAccessEditClick = function (item) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/business/modals/modal.external-access.edit.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.data = {
                        title: item.title,
                        scope: []
                    }
                    popup.scope = [];

                    $scope.data.scope.forEach(function (el) {
                        var checked = item.scope.find(function (scopeItem) {
                            return scopeItem === el.value;
                        })

                        popup.scope.push({
                            title: el.title,
                            value: el.value,
                            checked: !!checked
                        })
                    })

                    popup.onCreateAccess = function () {
                        popup.data.scope = [];
                        popup.scope.forEach(function (el) {
                            if (el.checked) {
                                popup.data.scope.push(el.value)
                            }
                        })
                        BusinessService.UpdateExternalAccess(item.id, popup.data, function (success, data) {
                            if (success) {
                                NotifyService.Success('', false);
                                loadExternalAccessInfo();
                                $uibModalInstance.close();
                            }
                        })
                    }
                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            })
        }

        $scope.onAccessDeleteClick = function (item) {
            BusinessService.RemoveExternalAccess(
                item.id,
                function (success, data) {
                    if (success) {
                        NotifyService.Success('', false);
                        loadExternalAccessInfo();
                    }
                }
            )

        }

        $scope.popupAPIKEY = function (api_key) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                templateUrl: 'app/pages/business/modals/modal.show-api-key.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.api_key = api_key;

                    popup.onAPIKEYCopy = function () {
                        popup.APIKEYCopied = true;
                        $timeout(function () {
                            popup.APIKEYCopied = false;
                        }, 3000);
                    };

                    popup.onCancelClick = function (exit) {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        function loadExternalAccessInfo() {
            block_external_access.start();
            BusinessService.GetExternalAccessList(function (success, data) {
                if (success) {
                    $scope.external_access = data;
                }
                block_external_access.stop();
            });
        }

        function loadExternalAccessScope() {
            BusinessService.GetExternalAccessScope(function (success, data) {
                if (success) {
                    $scope.data.scope = data;
                }
            })
        }

        // *********************************************************************************************
        //  END EDIT EXTERNAL ACCESS TEMPLATES
        // *********************************************************************************************

        $rootScope.$watch('isPosBlockVisible', function (newValue, oldValue) {
            $scope.isPosBlockVisible = angular.copy(newValue);
        });

        $rootScope.$watch('isTerminalsBlockVisible', function (newValue, oldValue) {
            $scope.isTerminalsBlockVisible = angular.copy(newValue);
        });
    }
})();
